var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHolidayPackageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6635 3.3325H10.7973C11.1306 2.99925 11.3305 2.5327 11.3305 1.9995C11.3305 0.86645 10.464 0 9.331 0C8.6645 0 7.4648 0.59985 6.665 1.39965C5.8652 0.59985 4.6655 0 3.999 0C2.86595 0 1.9995 0.86645 1.9995 1.9995C1.9995 2.5327 2.19945 2.99925 2.5327 3.3325H0.6665C0.2666 3.3325 0 3.5991 0 3.999V5.8652C0 5.93185 0.06665 5.9985 0.1333 5.9985H5.7319C5.8652 5.9985 5.9985 5.8652 5.9985 5.7319V3.5991C5.9985 3.4658 6.1318 3.3325 6.2651 3.3325H7.0649C7.1982 3.3325 7.3315 3.4658 7.3315 3.5991V5.7319C7.3315 5.8652 7.4648 5.9985 7.5981 5.9985H13.1967C13.2633 5.9985 13.33 5.93185 13.33 5.8652V3.999C13.33 3.5991 13.0634 3.3325 12.6635 3.3325ZM3.999 2.666C3.5991 2.666 3.3325 2.3994 3.3325 1.9995C3.3325 1.5996 3.5991 1.333 3.999 1.333C4.3989 1.333 5.5986 2.1328 5.93185 2.5327C5.7319 2.59935 3.999 2.666 3.999 2.666ZM9.331 2.666C9.331 2.666 7.5981 2.59935 7.39815 2.5327C7.79805 2.06615 8.9311 1.333 9.331 1.333C9.7309 1.333 9.9975 1.5996 9.9975 1.9995C9.9975 2.3994 9.7309 2.666 9.331 2.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7319 7.33203H0.799804C0.733154 7.33203 0.666504 7.39868 0.666504 7.46533V12.664C0.666504 13.0639 0.933104 13.3305 1.333 13.3305H5.7319C5.8652 13.3305 5.9985 13.1972 5.9985 13.0639V7.59863C5.9985 7.46533 5.8652 7.33203 5.7319 7.33203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5302 7.33203H7.59814C7.46484 7.33203 7.33154 7.46533 7.33154 7.59863V13.0639C7.33154 13.1972 7.46484 13.3305 7.59814 13.3305H11.997C12.3969 13.3305 12.6635 13.0639 12.6635 12.664V7.46533C12.6635 7.39868 12.5969 7.33203 12.5302 7.33203Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidayPackageIcon);
export default __webpack_public_path__ + "static/media/holidayPackageIcon.b352884e2d981f3152d09bd38c410b5e.svg";
export { ForwardRef as ReactComponent };